import React, { useEffect, useState } from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useAuth } from '../../../common/hooks/useAuth';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { NotAuthorized } from '../../../common/components/NotAuthorized/NotAuthorized';

import { ContractsView } from './ContractsView';
import { checkAccess } from './checkAccess';

export const ContractsOnlyForSomeBudgetTeamView: React.FC = () => {
  const pok = usePokCore();
  const auth = useAuth();
  const notifications = useNotifications();
  const [access, setAccess] = useState<boolean | null>(null);

  useEffect(() => {
    if (auth.currentUser && auth.currentUser.sub) {
      pok.employeesRoles
        .findBudgetsTeamsWithCompanyByUser(auth.currentUser.sub)
        .then(o => {
          if (checkAccess(o, pok.getCompanyId())) {
            setAccess(true);
          } else {
            setAccess(false);
          }
        })
        .catch(async errorResponse => {
          notifications.caughtError(errorResponse);
        });
    }
  }, [pok.employeesRoles, auth.currentUser, notifications, pok]);

  return (
    <>
      {access && <ContractsView tv={false} withAddButton={true} />}
      {access === false && <NotAuthorized />}
    </>
  );
};
